import {
	getDefaultItemPayload,
	getTitle,
	getMetaTags,
	renderToStaticMarkup,
	setDescription,
	setLinks,
	setMetaTags,
	setSchemas,
	setTitle,
	isComponentItemType,
} from '@wix/advanced-seo-utils/renderer'
import { SeoSchema } from '@wix/advanced-seo-utils'
import { convertDynamicPageModel, setExternalRouter } from '@wix/advanced-seo-utils/renderer-api'
import { getTags } from '@wix/advanced-seo-utils/async'
import { DynamicRouteData } from '@wix/thunderbolt-symbols'
import { resolveMetaTags } from './resolve-meta-tags'
import { MetaTag } from '../types'

export {
	getTags,
	getDefaultItemPayload,
	getTitle,
	setTitle,
	setLinks,
	setSchemas,
	setMetaTags,
	setDescription,
	isComponentItemType,
}

export const setWindowTitle = (title: string) => {
	if (process.env.browser) {
		window.document.title = title
	}
}

export const setDomOgUrl = (tags: SeoSchema) => {
	if (process.env.browser) {
		const OG_URL_PROPERTY = 'og:url'
		const [ogUrlTag]: Array<MetaTag> = getMetaTags(tags, { property: OG_URL_PROPERTY })

		if (ogUrlTag) {
			const { content } = ogUrlTag
			const existingElement = window.document.querySelector(`meta[property="${OG_URL_PROPERTY}"]`)

			existingElement?.setAttribute('content', content)
			if (!existingElement) {
				const ogUrlElement = window.document.createElement('meta')
				ogUrlElement.setAttribute('property', OG_URL_PROPERTY)
				ogUrlElement.setAttribute('content', content)
				const head = window.document.querySelector('head')
				head?.appendChild(ogUrlElement)
			}
		}
	}
}

export const getStaticMarkup = (tags: any) => renderToStaticMarkup(tags).join('\n  ') // indenting every tag for final render

export const convertTPAEndpointModel = async (tpaEnapointData: any) => {
	const converters = await import('@wix/advanced-seo-utils/converters' /* webpackChunkName: "seo-api-converters" */)
	return converters.convertTpaModel(tpaEnapointData)
}

export const extractDynamicRouteData = (
	payload: DynamicRouteData,
	mediaItemUtils: any,
	currentVeloOverrides: Array<MetaTag> = []
) => {
	if (payload) {
		const { pageHeadData = {} } = payload
		const resolvedPageHeadData = {
			...pageHeadData,
			metaTags: resolveMetaTags(pageHeadData.metaTags || {}, mediaItemUtils),
		}
		const veloOverrides = setExternalRouter(currentVeloOverrides, resolvedPageHeadData)
		const dynamicPageData = convertDynamicPageModel(resolvedPageHeadData)
		return {
			veloOverrides,
			dynamicPageData,
		}
	}
}
